package com.example.hukakmp.model

data class HukaUser(
    val uid: String,
    val email: String?,
    val displayName: String?,
    val photoUrl: String?,
)
